<template>
  <div>
    <div class="item-box-content">
      <div class="title-font-style">
        <span>退货方案</span>
      </div>
      <div style="padding: 0 30px 10px">
        <div v-if="params.returnPlainStatus<4">
          <div class="maintain-scheme">
            <div v-show="params.returnPlainStatus===1">
              <div>
                <i
                  class="iconfont icon-xiaoshou-tuihuo-denghou"
                  style="color:#60C96D;font-size:42px;"
                ></i>
              </div>
              <div class="title">请等待退货审批！</div>
            </div>
            <div v-show="params.returnPlainStatus===3">
              <div class="el-icon-error" style="color:#D35E5E;font-size:42px"></div>
              <div class="title">退货审批不通过！</div>
              <div class="text">拒绝原因：{{params.mark}}</div>
            </div>
          </div>
        </div>
        <div v-else>
          <el-table
            style="margin-top:20px;"
            border
            ref="tableRef"
            :data="totalList"
            tooltip-effect="dark"
            :header-cell-style="tableHeader"
          >
            <el-table-column label="退货产品销售总额">
              <template slot-scope="scope">{{scope.row.salePriceTotal|priceFilterNum}}</template>
            </el-table-column>
            <el-table-column label="罚没总额">
              <template slot-scope="scope">{{scope.row.forfeitureProiceTotal|priceFilterNum}}</template>
            </el-table-column>
            <el-table-column label="罚没比例">
              <template slot-scope="scope">{{scope.row.forfeiturePenaltyTotal|perCentFilter}}</template>
            </el-table-column>
          </el-table>
          <el-table
            style="margin-top:20px;"
            border
            ref="tableRef"
            :data="detailsList"
            tooltip-effect="dark"
            :span-method="objectSpanMethod"
            :header-cell-style="tableHeader"
          >
            <el-table-column label="备货方式">
              <template slot-scope="scope">{{scope.row.type}}</template>
            </el-table-column>
            <el-table-column label="退货方案" width="90">
              <template slot-scope="scope">{{scope.row.plain}}</template>
            </el-table-column>
            <el-table-column label="销售总额">
              <template slot-scope="scope">{{scope.row.priceTotal|priceFilterNum}}</template>
            </el-table-column>
            <el-table-column label="罚没金额">
              <template slot-scope="scope">{{scope.row.forfeitureProice|priceFilterNum}}</template>
            </el-table-column>
            <el-table-column label="罚没比例">
              <template slot-scope="scope">{{scope.row.forfeiturePenalty|perCentFilter}}</template>
            </el-table-column>
          </el-table>
          <div v-if="params.returnPlainStatus!==11">
            <div class="form-title">{{params.returnPlainStatus===4?'请设置费用结算方案：':'费用结算方案：'}}</div>
            <el-form
              :class="params.returnPlainStatus!==4?'details-line-height':''"
              label-position="right"
              label-width="70px"
            >
              <el-row>
                <el-col :span="12">
                  <el-form-item label="客户承担：">
                    <el-input-number
                      v-model="queryParams.customerCommitment"
                      :controls="false"
                      :min="0"
                      :precision="2"
                      v-if="params.returnPlainStatus===4"
                    ></el-input-number>
                    <span v-else>{{queryParams.customerCommitment|priceFilter}}</span>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="公司承担：">
                    <el-input-number
                      v-model="queryParams.companyCommitment"
                      :controls="false"
                      :min="0"
                      :precision="2"
                      v-if="params.returnPlainStatus===4"
                    ></el-input-number>
                    <span v-else>{{queryParams.companyCommitment|priceFilterNum}}</span>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="提成结算：">
                    <el-input-number
                      v-model="queryParams.commissionSettlement"
                      :controls="false"
                      :min="0"
                      :precision="2"
                      v-if="params.returnPlainStatus===4"
                    ></el-input-number>
                    <span v-else>{{queryParams.commissionSettlement|priceFilterNum}}</span>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="合同结算：">
                    <el-input-number
                      v-model="queryParams.contractSettlement"
                      :controls="false"
                      :min="0"
                      :precision="2"
                      v-if="params.returnPlainStatus===4"
                    ></el-input-number>
                    <span v-else>{{queryParams.contractSettlement|priceFilterNum}}</span>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="费用小计：">
                    <span
                      v-if="params.returnPlainStatus===4"
                    >{{((queryParams.companyCommitment||0) + (queryParams.customerCommitment||0)+(queryParams.commissionSettlement||0) +(queryParams.contractSettlement||0))|priceFilterNum}}</span>
                    <span v-else>{{queryParams.subtotalExpenses|priceFilterNum}}</span>
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item
                    label="备注："
                    :label-width="params.returnPlainStatus!==4?'42px':'70px'"
                  >
                    <el-input
                      type="textarea"
                      :rows="3"
                      v-model="queryParams.mark"
                      v-if="params.returnPlainStatus===4"
                    ></el-input>
                    <span v-else>{{queryParams.mark}}</span>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </div>
        </div>
        <div class="text-box" v-show="params.returnPlainStatus===4">
          费用说明：
          <br />1. 设置客户支付费用后，罚没费用需要客户承担，最终罚没金额将通过退款结算进行结算；
          <br />2. 设置公司承担费用后，客户及业务均无需承担任何罚没费用，且不影响合同的业绩提成；
          <br />3. 设置提成结算或合同结算后，费用分别自业务员当月的业绩提成及合同流水中扣除；
          <br />4. 费用小计金额需大于等于罚没金额；
          <br />5. 结算方式审批通过后，仅允许对客户支付部分开具相应发票；
          <br />6. 退货商品全部入库且完成结算罚没金额，当前售后流程状态方修正为退货完成。
        </div>
        <div v-show="params.returnPlainStatus===4">
          <el-button type="primary" @click="onSubmit">提交审批</el-button>
          <el-button @click="onAbandon">放弃退货</el-button>
        </div>
        <el-steps :active="active" style="width:85%;margin:20px auto 10px" class="mainStep" align-center>
          <el-step
            :title="item"
            v-for="(item, i) in stepList"
            :key="i"
            :icon="item==='审批不通过'||item==='结算审批不通过'?'':'el-icon-success'"
            :status="item==='审批不通过'||item==='结算审批不通过'?'error':''"
          ></el-step>
        </el-steps>
        <div style="color:#D35E5E;font-size: 12px;">
          <span v-show="params.returnPlainStatus===3">流程结束，所有产品返回正常状态，可通过售后管理页面再次发起申请。</span>
          <span v-show="params.returnPlainStatus===6">结算审批不通过</span>
          <span
            v-show="params.returnPlainStatus===7"
          >退货产品中存在未退票产品，流程将在完成退票后继续执行；已核销产品可申请红字发票，未核销发票可通过退票方式退回；如需对罚没金额开具发票，请前往右侧罚没金开票。</span>
          <span
            v-show="params.returnPlainStatus===8"
          >当前退货产品均已退票，请联系客户退回货物，并通过右侧物流管理补充入库信息商品均入库后，方可开启退款结算。</span>
          <span v-show="params.returnPlainStatus===10">当前商品均已入库，请前往右侧退款结算模块完成结算。</span>
          <span v-show="params.returnPlainStatus===12">退款已结算，退货完成。</span>
        </div>
        <div v-show="params.returnPlainStatus===6">
          <div style="margin:20px auto">备注：{{params.mark}}</div>
          <div>
            <el-button type="primary" icon="el-icon-back" @click="onReturn">返回方案确认</el-button>
          </div>
        </div>
        <div v-if="params.returnPlainStatus===7&&invoiceBtn!==2" style="margin-top:20px">
          <el-button type="primary" @click="onRedApplyForReturnTicket">申请红字发票</el-button>
          <el-button @click="onApplyForReturnTicket">申请退票</el-button>
        </div>
      </div>
    </div>
    <div class="item-box-content">
      <el-row>
        <el-col :span="12">
          <div class="title-font-style">
            <span>退货清单</span>
          </div>
        </el-col>
        <el-col :span="12" style="text-align:right;" v-show="params.returnPlainStatus===4">
          <el-button v-show="!isShow" @click="isShow=true">调整数量</el-button>
          <el-button type="primary" v-show="isShow" @click="onUpdataState(85)">提交</el-button>
        </el-col>
      </el-row>
      <el-table
        style="margin-top:20px;"
        border
        ref="tableRef"
        :data="totalsList"
        tooltip-effect="dark"
        :header-cell-style="tableHeader"
      >
        <el-table-column label="销售总额">
          <template slot-scope="scope">{{scope.row.salePriceTotal|priceFilterNum}}</template>
        </el-table-column>
        <el-table-column label="未备货产品销售总额">
          <template slot-scope="scope">{{scope.row.stockupZeroPrice|priceFilterNum}}</template>
        </el-table-column>
        <el-table-column label="已备货未发货产品销售总额">
          <template slot-scope="scope">{{scope.row.deliverStateNotZeroPrice|priceFilterNum}}</template>
        </el-table-column>
        <el-table-column label="已发货产品销售总额">
          <template slot-scope="scope">{{scope.row.deliverStateThreePrice|priceFilterNum}}</template>
        </el-table-column>
      </el-table>
      <div v-for="(item,i) in list " :key="i" v-show="item.arr.length">
        <div class="title">
          <span class="ht">{{item.title}}</span>
          <span class="text">{{item.text}}</span>
        </div>
        <el-table
          border
          ref="tableRef"
          :data="item.arr"
          tooltip-effect="dark"
          :header-cell-style="tableHeader"
          max-height="378"
        >
          <el-table-column label="品牌" prop="brandName" show-overflow-tooltip></el-table-column>
          <el-table-column label="型号" prop="proType" show-overflow-tooltip></el-table-column>
          <el-table-column label="订货号" prop="orderNumber" show-overflow-tooltip></el-table-column>
          <el-table-column label="数量" width="120">
            <template slot-scope="scope">
              <span v-show="!isShow">{{scope.row.count}}</span>
              <el-input-number
                style="width:100%"
                v-show="isShow"
                v-model="scope.row.count"
                controls-position="right"
                @change="handleChange(scope.$index,i)"
                :min="1"
                :max="scope.row.max"
              ></el-input-number>
            </template>
          </el-table-column>
          <el-table-column label="产品序列号" width="100px" v-if="i===2">
            <template slot-scope="scope">
              <el-button
                type="text"
                @click="onSee(scope.row,1)"
                v-if="!isShow||(scope.row.count===scope.row.max&&!scope.row.isproSerial)"
              >查看</el-button>
              <el-button type="text" @click="onSee(scope.row,2,scope.$index)" v-else>点击录入</el-button>
            </template>
          </el-table-column>
          <el-table-column label="销售单价">
            <template slot-scope="scope">{{scope.row.cbPrice|priceFilterNum}}</template>
          </el-table-column>
          <el-table-column label="在库状态" v-if="i!==0">
            <template slot-scope="scope">{{scope.row.inventoryState===1?'已入库':'待入库'}}</template>
          </el-table-column>
          <el-table-column label="备货状态" v-if="i===1">
            <template slot-scope="scope">{{scope.row.stockupState|stockupStateFilter}}</template>
          </el-table-column>
          <el-table-column label="开票状态">
            <template slot-scope="scope">{{scope.row.invoiceState|invoiceStateFilter}}</template>
          </el-table-column>
          <el-table-column label="退货方案" width="90">
            <template slot-scope="scope">{{!i?'停止备货':scope.row.fallbackPath===1?'退至仓库':'退至供应商'}}</template>
          </el-table-column>
          <el-table-column label="罚没单价">
            <template slot-scope="scope">{{scope.row.forfeitureProice|priceFilterNum}}</template>
          </el-table-column>
          <el-table-column label="罚没比例">
            <template slot-scope="scope">{{scope.row.forfeiturePenalty|perCentFilter}}</template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <!-------------- 录入产品序列号 ------------>
    <inprouct-serial-code-dialog @inProuctSerial="inProuctSerial" ref="inProuctSerialCodeRefs"></inprouct-serial-code-dialog>
    <!-------------- 查看发货清单 -------------->
    <see-shipment ref="seeShipmentRefs" :showF="true"></see-shipment>
    <open-or-close
      ref="OpenOrCloseRefs"
      @onUpdataState="onUpdataState"
      :title="title"
      :content="content"
    ></open-or-close>
  </div>
</template>

<script>
import seeShipment from '../shipments/seeShipment'
import OpenOrClose from '@/components/OpenOrClose/index'
import inProuctSerialCodeDialog from '@/views/purchase/purchaseManage/dialog/inProuctSerialCodeDialog' // 序列号
import {
  costSettlementCommit,
  giveUpReturnGoods,
  returnPlainConfirm,
  countAdjustment
} from '@/api/sell/sellManage'
export default {
  props: ['params'],
  components: {
    'see-shipment': seeShipment,
    'inprouct-serial-code-dialog': inProuctSerialCodeDialog,
    'open-or-close': OpenOrClose
  },
  data() {
    return {
      list: [
        {
          title: '未备货产品',
          text: '以下产品不再允许发起备货请求',
          arr: []
        },
        {
          title: '已发起备货未发货产品',
          text: '以下产品不再允许发起发货请求',
          arr: []
        },
        {
          title: '已发货产品',
          arr: []
        }
      ],
      queryParams: {},
      stepList: [],
      detailsList: [],
      totalList: [],
      totalsList: [],
      active: 2,
      isShow: false,
      typeNum: 0,
      title: '',
      content: '',
      invoiceBtn: 1
    }
  },
  watch: {
    params: {
      handler(val) {
        if (val.returnPlainStatus === 3) {
          this.active = 2
          this.stepList = ['发起申请', '审批不通过']
        } else if (val.returnPlainStatus === 11) {
          this.active = 2
          this.stepList = ['制定结算方案', '放弃退货']
        } else if (val.returnPlainStatus === 6) {
          this.stepList = [
            '发起申请',
            '退货审批',
            '制定结算方案',
            '费用结算审批',
            '结算审批不通过'
          ]
          this.active = 5
        } else if (val.returnPlainStatus < 6) {
          // 1 4 5
          this.stepList = [
            '发起申请',
            '退货审批',
            '制定结算方案',
            '费用结算审批'
          ]
          this.active =
            val.returnPlainStatus === 1 ? 2 : val.returnPlainStatus - 1
        } else {
          this.invoiceBtn = val.invoiceBtn
          this.stepList = [
            '票据回收',
            '待入库',
            '已入库',
            '退款结算',
            '退货完成'
          ]
          this.active = val.returnPlainStatus - 6
        }
        this.queryParams = val.costSettlementSchemeVo || {}
        this.list[0].arr = val.orderContractSaleReturnGoodsContentStockupZero
        this.list[1].arr =
          val.orderContractSaleReturnGoodsContentDeliverStateNotZero
        this.list[2].arr =
          val.orderContractSaleReturnGoodsContentDeliverStateThree
        this.list.forEach((item) => {
          item.arr.forEach((ele) => {
            ele.max = ele.count
          })
        })
        this.detailsList = val.returnGoodsPlainVo
        this.totalList = [val]
        this.totalsList = [val]
      },
      deep: true
    }
  },
  methods: {
    checkoutNum() {
      let isF = false
      this.list.forEach(m => [
        m.arr.forEach(n => {
          if (!n.count) {
            isF = true
          }
        })
      ])
      return isF
    },
    onUpdataState(type) {
      if (this.checkoutNum()) {
        this.$message.error('不能存在无数量退货产品')
        return
      }
      const params = {
        costSettlementSchemeVo: this.queryParams,
        orderContractSaleReturnGoodsContentStockupZero: this.list[0].arr,
        orderContractSaleReturnGoodsContentDeliverStateNotZero: this.list[1]
          .arr,
        orderContractSaleReturnGoodsContentDeliverStateThree: this.list[2]
          .arr,
        returnGoodsPlainVo: this.detailsList,
        orderContractSalereturnGoods: this.params
          .orderContractSalereturnGoods,
        salePriceTotal: this.totalList[0].salePriceTotal,
        forfeitureProiceTotal: this.totalList[0].forfeitureProiceTotal,
        forfeiturePenaltyTotal: this.totalList[0].forfeiturePenaltyTotal,
        stockupZeroPrice: this.totalsList[0].stockupZeroPrice,
        deliverStateNotZeroPrice: this.totalsList[0].deliverStateNotZeroPrice,
        deliverStateThreePrice: this.totalsList[0].deliverStateThreePrice
      }
      if (type === 85) {
        countAdjustment(params).then((res) => {
          if (res.data.code === 200) {
            this.$message.success('操作成功')
            this.$emit('onRefresh')
            this.isShow = false
          }
        })
        return
      }
      if (this.typeNum === 1) {
        costSettlementCommit(params).then((res) => {
          if (res.data.code === 200) {
            this.$message.success('已提交结算方案，请等待方案审批')
            this.$emit('onRefresh')
          }
        })
      } else {
        giveUpReturnGoods(this.$route.query.id).then((res) => {
          if (res.data.code === 200) {
            this.$message.success('已放弃退货')
            this.$emit('onRefresh')
          }
        })
      }
    },
    onReturn() {
      returnPlainConfirm(this.$route.query.id).then((res) => {
        if (res.data.code === 200) {
          this.$emit('onRefresh')
        }
      })
    },
    onAbandon() {
      this.typeNum = 2
      this.title = '放弃退货'
      this.content =
        '请再次确认是否确认放弃本次退货申请，放弃后退货商品将恢复正常备发货状态'
      this.$refs.OpenOrCloseRefs.onInitial()
    },
    onSubmit() {
      // 提交结算方案
      this.queryParams.subtotalExpenses =
        (this.queryParams.companyCommitment || 0) +
        (this.queryParams.customerCommitment || 0) +
        (this.queryParams.commissionSettlement || 0) +
        (this.queryParams.contractSettlement || 0)
      if (
        this.queryParams.subtotalExpenses <
        this.totalList[0].forfeitureProiceTotal
      ) {
        this.$message.error('费用小计不得小于罚没总额！')
      } else {
        this.typeNum = 1
        this.title = '确认执行'
        this.content = '请再次确认是否确认执行当前方案，确认执行后无法撤回。'
        this.$refs.OpenOrCloseRefs.onInitial()
      }
    },
    handleChange(i, ty) {
      this.list[ty].arr[i].isproSerial = true
      if (ty === 2) {
        this.list[2].arr[i].proSerialNumber = null
      }
      const obj = {
        total1: 0, // 销售总额
        total2: 0, // 未备
        total3: 0, // 已备未发
        total4: 0, // 已发
        total5: 0, // 供应商
        total6: 0 // 仓库
      }
      this.list.forEach((item, i) => {
        item.arr.forEach((ele) => {
          const total = ele.count ? ele.count * ele.cbPrice : 0
          obj.total1 += total
          if (i === 0) {
            obj.total2 += total
          } else {
            if (i === 1) {
              obj.total3 += total
            } else {
              obj.total4 += total
            }
            if (ele.plain === '退至供应商') {
              obj.total5 += total
            } else {
              obj.total6 += total
            }
          }
        })
      })
      this.totalList[0].salePriceTotal = obj.total1
      this.totalList[0].forfeitureProiceTotal =
        obj.total1 * this.totalList[0].forfeiturePenaltyTotal
      this.totalsList[0].salePriceTotal = obj.total1
      this.totalsList[0].stockupZeroPrice = obj.total2
      this.totalsList[0].deliverStateNotZeroPrice = obj.total3
      this.totalsList[0].deliverStateThreePrice = obj.total4
      const in1 = this.detailsList.findIndex((m) => m.plain === '停止备货')
      const in2 = this.detailsList.findIndex((m) => m.plain === '退至供应商')
      const in3 = this.detailsList.findIndex((m) => m.plain === '退至仓库')
      if (in1 !== -1) {
        this.detailsList[in1].priceTotal = obj.total2
        this.detailsList[in1].forfeitureProice =
          obj.total2 * this.detailsList[in1].forfeiturePenalty
      }
      if (in2 !== -1) {
        this.detailsList[in2].priceTotal = obj.total5
        this.detailsList[in2].forfeitureProice =
          obj.total5 * this.detailsList[in2].forfeiturePenalty
      }
      if (in3 !== -1) {
        this.detailsList[in3].priceTotal = obj.total6
        this.detailsList[in3].forfeitureProice =
          obj.total6 * this.detailsList[in3].forfeiturePenalty
      }
    },
    onApplyForReturnTicket() {
      // 申请退票
      this.$router.push({
        name: 'applyForReturnTicket',
        query: {
          oscId: this.$route.query.id,
          cusId: this.$route.query.cusId
        }
      })
    },
    onRedApplyForReturnTicket() {
      // 红字申请发票
      this.$router.push({
        name: 'redApplyForReturnTicket',
        query: {
          oscId: this.$route.query.id,
          cusId: this.$route.query.cusId,
          type: 'red'
        }
      })
    },
    // 查看 序列号
    onSee(val, num, i) {
      if (num === 1) {
        // 查看
        this.$refs.seeShipmentRefs.onInitial(val, this.id, true)
      } else if (num === 2) {
        // 录入
        val.serialCode = val.proSerialNumber
        this.$refs.inProuctSerialCodeRefs.onInitial(val, i, val.serialCode ? 1 : 0)
      }
    },
    // 序列号传回来的值
    inProuctSerial(val, i) {
      this.list[2].arr[i].proSerialNumber = val
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        if (rowIndex === 1) {
          return {
            rowspan: 2,
            colspan: 1
          }
        } else if (rowIndex === 2) {
          return {
            rowspan: 2,
            colspan: 0
          }
        } else {
          return {
            rowspan: 1,
            colspan: 1
          }
        }
      }
    },
    tableHeader({ rowIndex }) {
      return this.$tableHeader(rowIndex)
    }
  }
}
</script>
<style lang="scss" scoped>
.maintain-scheme {
  padding: 30px;
  background: #f3f7ff;
  border-radius: 4px;
  text-align: center;
  margin-top: 20px;
  .title {
    margin: 0 auto;
    font-size: 18px;
    font-weight: 500;
    color: #4e555b;
    line-height: 32px;
  }
  .text {
    font-weight: 400;
    color: #83878a;
    line-height: 20px;
  }
}
.text-box {
  margin-bottom: 20px;
  font-weight: 500;
  line-height: 21px;
  color: #83878a;
  font-size: 12px;
}
.title {
  margin: 30px 0 14px;
  .ht {
    font-size: 16px;
    font-weight: bold;
    color: #4e555b;
  }
  .text {
    margin-left: 20px;
    font-size: 12px;
    font-weight: 400;
    color: #d35e5e;
    line-height: 12px;
  }
}
.form-title {
  font-size: 16px;
  font-weight: bold;
  color: #4e555b;
  line-height: 24px;
  margin: 20px 0 20px;
}
</style>
